export default __webpack_public_path__ + "static/media/googleDriveLogo.fe9a48fa.png";